import styled from 'styled-components';

export const Root = styled.div``;

export const ConditionalDisplay = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
`;
